module.exports = __webpack_public_path__ + "4bfd801cc6456a51a89957b293d6200f.svg";